// frontend/src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar.jsx';
import HeroSection from './components/HeroSection.jsx';
import Services from './components/Services.jsx';
import AboutUs from './components/AboutUs.jsx';
import Testimonials from './components/Testimonials.jsx';
import ContactForm from './components/ContactForm.jsx';
import Footer from './components/Footer.jsx';

import MaritimeAI from './pages/maritime-ai/MaritimeAI.jsx';
import Privacy from './pages/privacy/Privacy.jsx';
import Terms from './pages/terms/Terms.jsx';

export default function App() {
  return (
    <Router>
      <div className="font-sans text-gray-800">
        {/* Navbar is often kept outside Routes if you want it on every page */}
        <Navbar />

        <Routes>
          {/* Home route: renders your original single-page sections */}
          <Route
            path="/"
            element={
              <>
                <HeroSection />
                <Services />
                <AboutUs />
                <Testimonials />
                <ContactForm />
              </>
            }
          />

          {/* Maritime AI route: the separate page */}
          <Route path="/maritime-ai" element={<MaritimeAI />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>

        {/* Footer can also be outside Routes or inside each route. 
            If you only want one global Footer, keep it here. */}
        <Footer />
      </div>
    </Router>
  );
}
